// pull config object from bundled json file
const account = 'app'
const configFromJSON = require(`./config/${account}.config.json`)

// overrides
const config = {
  ...configFromJSON,
  domain: 'localhost',
  //mask: 'promach.bam.zone',
}

export default config
